import React from 'react'

import ContentPage from './ContentPage.jsx'

import es from '../locales/blog_es.json'
import en from '../locales/blog_en.json'

function Blog() {
    return <ContentPage es={es} en={en} />
}

export default Blog
